import { useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';
import { DataItem } from '../types/base';

export const useBasesData = (isAdmin: boolean, filterBySale = false) => {
  const [data, setData] = useState<DataItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const getLimit = (offset: number) => (offset === 0 ? 20 : 10);

  const fetchData = useCallback(
    async (reset = false) => {
      if (!hasMore && !reset) return;

      setIsLoading(true);
      try {
        const newOffset = reset ? 0 : offset;
        const limit = getLimit(newOffset);

        const response = await api.get(
          `/telegram/sales/db/?offset=${newOffset}&limit=${limit}${
            filterBySale ? '&sale=true' : ''
          }`,
        );
        const newData = response.data || [];

        const filteredData = filterBySale
          ? newData.filter((item: DataItem) => item.sale === true)
          : newData;

        setData((prev) => (reset ? filteredData : [...prev, ...filteredData]));
        setHasMore(newData.length === limit);
        if (!reset) setOffset((prev) => prev + limit);
        else setOffset(limit);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    },
    [offset, hasMore, filterBySale],
  );

  useEffect(() => {
    fetchData(true);
  }, [isAdmin, filterBySale]);

  return {
    data,
    isLoading,
    hasMore,
    fetchData,
    refresh: () => fetchData(true),
  };
};
